import React, { useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

const RestaurantCard = ({ restaurant }) => {
  const cardRef = useRef(null);
  
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          cardRef.current.classList.add('visible');
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.2 }
    );
    
    if (cardRef.current) {
      observer.observe(cardRef.current);
    }
    
    return () => {
      if (cardRef.current) {
        observer.unobserve(cardRef.current);
      }
    };
  }, []);

  return (
    <Link to={`/restaurant/${restaurant.id}`} className="restaurant-link">
      <div 
        ref={cardRef} 
        className="restaurant-card animate-on-scroll slide-from-bottom"
      >
        <img 
          src={restaurant.image} 
          alt={restaurant.name} 
          className="restaurant-card-img" 
        />
        <div className="restaurant-card-content">
          <h3 className="restaurant-card-title">{restaurant.name}</h3>
          <p className="restaurant-card-desc">{restaurant.description}</p>
        </div>
      </div>
    </Link>
  );
};

export default RestaurantCard;